import React from "react";
import { Field } from "formik";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
const AWS_AUTH_TYPES_OPTIONS = [
  { value: "automatic", label: "Automatic" },
  { value: "keysecret", label: "Key & Secret" }
];
const AWSAuthenticationTypeFormGroup = ({ updateAuthenticationType = () => {
}, currentType = "automatic" }) => /* @__PURE__ */ React.createElement(Field, null, () => /* @__PURE__ */ React.createElement(Input, { id: "default-aws-auth-type-select", label: "AWS Authentication Type" }, /* @__PURE__ */ React.createElement(
  Select,
  {
    id: "awsAuthenticationType",
    name: "AWSAuthenticationType",
    placeholder: "Select Authentication Type",
    options: AWS_AUTH_TYPES_OPTIONS,
    onChange: (option) => {
      updateAuthenticationType(option);
    },
    value: currentType
  }
)));
export default AWSAuthenticationTypeFormGroup;
